// extracted by mini-css-extract-plugin
export default {"messagesScrollable":"chat-window_messagesScrollable__mFkEC","messagesInner":"chat-window_messagesInner__p08XX","aiWelcome":"chat-window_aiWelcome__K0bWg"};